import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  ImageSizeFieldSchema,
  RichTextFieldSchema,
  UrlFieldSchema,
} from './Types';
import { z } from 'zod';

const BodyText = RichTextFieldSchema.extend({
  name: z.literal('body'),
  role: z.literal(FieldRole.Body),
});

const CTAUrlFieldSchema = UrlFieldSchema.extend({
  name: z.literal('calendarUrl'),
  role: z.literal(FieldRole.CtaUrl),
});

const CTATextFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('ctaText'),
  role: z.literal(FieldRole.CtaText),
});

const OwnerImageFieldSchema = ImageFieldSchema.extend({
  name: z.literal('profilePicture'),
  role: z.literal(FieldRole.Image),
});

const ProfilePictureSizeFieldSchema = ImageSizeFieldSchema.extend({
  name: z.literal('profilePictureSize'),
  role: z.literal(FieldRole.Image),
});

// Create the schema and type of that schema for all the fields of the block
const NaiveBookMeetingFieldSchema = z.discriminatedUnion('name', [
  BodyText,
  CTAUrlFieldSchema,
  CTATextFieldSchema,
  OwnerImageFieldSchema,
  ProfilePictureSizeFieldSchema,
]);

// Create the schema and type of that schema for the field group of the block
// In this case, there is only one field group.
const NaiveBookMeetingFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(NaiveBookMeetingFieldSchema),
});

enum NaiveBookMeetingLayout {
  Left = 'left',
  Right = 'right',
}

const NaiveBookMeetingLayoutSchema = z.nativeEnum(NaiveBookMeetingLayout);

// Block options schema and type
const NaiveBookMeetingBlockOptionsSchema = z.object({
  style: z
    .object({
      backgroundColor: z.string().optional(),
      backgroundPosition: z.string().optional(),
      backgroundImage: z.string().optional(),
    })
    .optional(),
  layout: NaiveBookMeetingLayoutSchema.optional(),
  colorScheme: ColorSchemeSchema.optional(),
});

// Block config schema and type
export const NaiveBookMeetingBlockConfigSchema = z.object({
  options: NaiveBookMeetingBlockOptionsSchema,
  type: z.literal(BlockType.NaiveBookMeeting),
  fieldGroups: z.tuple([NaiveBookMeetingFieldGroupSchema]),
  version: z.literal(1),
});
